import { requestApi } from 'api/api'
import {
  LedgerWalletsRequestParams,
  LedgerWalletsResponse,
  LedgerWalletTransactionsRequestParams,
  LedgerWalletTransactionsResponse,
} from 'types/ledger/ledgerWalletTransactions'
import { API_PAGINATION_LIMIT, API_PAGINATION_OFFSET } from 'utils/pagination'

export const getLedgerWalletTransactions = ({
  walletReference,
  size = API_PAGINATION_LIMIT,
  page = API_PAGINATION_OFFSET,
  start,
  end,
  statuses,
  filterMode,
  categories,
}: LedgerWalletTransactionsRequestParams): Promise<LedgerWalletTransactionsResponse> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: '/ledger/v1/transactions',
    method: 'GET',
    params: {
      ...(size !== undefined && { size }),
      ...(page !== undefined && { page }),
      ...(start && { start }),
      ...(end && { end }),
      ...(statuses?.length > 0 && { statuses: statuses.join(',') }),
      ...(walletReference && { walletId: walletReference }),
      ...(filterMode && { filterMode }),
      ...(categories?.length > 0 && { categories: categories.join(',') }),
    },
  })
}

export const getLedgerWallets = ({
  currencyCode,
  searchTerm,
  size = API_PAGINATION_LIMIT,
  page = API_PAGINATION_OFFSET,
  start,
  end,
  includeCustomerWallets,
}: LedgerWalletsRequestParams): Promise<LedgerWalletsResponse> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: '/ledger/v1/wallets',
    method: 'GET',
    params: {
      ...(size !== undefined && { size }),
      ...(page !== undefined && { page }),
      ...(start && { start }),
      ...(end && { end }),
      ...(currencyCode && { currencyCode }),
      ...(searchTerm && { q: searchTerm }),
      ...(includeCustomerWallets !== undefined && { includeCustomerWallets }),
    },
  })
}
